import { cn } from "@/lib/cn";

interface SlideNavProps {
  slides: readonly { id: string; label: string }[];
  currentSlide: number;
  goTo: (index: number) => void;
}

export function SlideNav({ slides, currentSlide, goTo }: SlideNavProps) {
  return (
    <nav
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1.5"
      aria-label="Slide navigation"
    >
      {slides.map((s, i) => (
        <button
          key={s.id}
          onClick={() => goTo(i)}
          className="group relative flex items-center justify-center py-2 px-0.5"
          aria-label={`Go to ${s.label}`}
          aria-current={currentSlide === i ? "step" : undefined}
        >
          {/* Hover tooltip */}
          <span className="absolute bottom-full mb-2 text-[9px] font-[family-name:var(--font-mono)] tracking-wider uppercase whitespace-nowrap text-[var(--color-fg-secondary)] opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            {s.label}
          </span>
          <span
            className={cn(
              "w-2 h-2 rounded-full border transition-all",
              currentSlide === i
                ? "bg-[var(--color-accent)] border-[var(--color-accent)] scale-125"
                : "border-[var(--color-fg-tertiary)] group-hover:border-[var(--color-fg-secondary)]"
            )}
          />
        </button>
      ))}
      {/* Current slide label */}
      <span className="ml-3 text-[10px] font-[family-name:var(--font-mono)] tracking-wider uppercase text-[var(--color-fg-tertiary)]">
        {slides[currentSlide]?.label}
      </span>
    </nav>
  );
}
